import SolutionItemMobile from "./SolutionItemMobile";
import SharkyRunning from "../../assets/images/Sharky/Sharky_Running.png" 
import './Solutions.css'
import { useTranslation } from 'react-i18next';

import Corporate from '../../assets/images/Photo/corporate.jpg'
import Merch from '../../assets/images/Photo/merch.webp'
import Sharky from '../../assets/images/Photo/sharky.png'
import Bottle from '../../assets/images/Photo/bottle.jpg'

function SolutionsMobile() {
    const { t } = useTranslation(['common']);
    
    return (
        <div id='section-solutions' className='flex flex-col items-start justify-start pt-24 w-full min-h-dvh overflow-hidden bg-bluekali-tomato'>
            <h1 className="text-3xl font-bold w-1/2 pl-6">{t('solutions.title1')}&nbsp;<span className="text-bluekali-cerulean-blue">{t('solutions.title2')}</span></h1>
            <img src={SharkyRunning} alt="" className="absolute right-0 rotate-6 -scale-x-[1] z-10 h-28 mr-4 shadow-right"/>
                <SolutionItemMobile className={'rounded-t-2xl'}
                    title={t('solutions.sol1.title')}
                    description={<>{t('solutions.sol1.shortdesc')}</>}
                    Image={Corporate}
                    YOffset={30}
                >
                    <div className="flex flex-col w-full mt-4 pr-6 space-y-4 items-start justify-start">
                        <div className='bg-bluekali-cerulean-blue/80 p-4 rounded-md '>
                        <h3 className="text-sm font-semibold mb-2">{t('solutions.sol1.includes')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol1.snack')}</li>
                            <li>{t('solutions.sol1.kit')}</li>
                            <li>{t('solutions.sol1.dynamic')}</li>
                            <li>{t('solutions.sol1.faci')}</li>
                            <li>{t('solutions.sol1.report')}</li>
                            <li>{t('solutions.sol1.sharky')}</li>
                            <li>{t('solutions.sol1.merch')}</li>
                        </ul>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 rounded-md'>
                        <h3 className="text-sm font-semibold mb-2">{t('solutions.sol1.benefits')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol1.image')}</li>
                            <li>{t('solutions.sol1.esg')}</li>
                            <li>{t('solutions.sol1.compromise')}</li>
                            <li>{t('solutions.sol1.communities')}</li>
                            <li>{t('solutions.sol1.solutions')}</li>
                            <li>{t('solutions.sol1.innovation')}</li>
                        </ul>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 rounded-md'>
                        <h3 className="text-xl font-semibold">{t('solutions.sol1.price')}</h3>
                        <p className="text-sm mb-2">{t('solutions.sol1.factors')}</p>
                        <ul className="space-y-1 text-sm">
                            <li>{t('solutions.sol1.number')}</li>
                            <li>{t('solutions.sol1.location')}</li>
                            <li>{t('solutions.sol1.alcance')}</li>
                            <li>{t('solutions.sol1.goal')}</li>
                        </ul>
                        </div>

                        
                    </div>
                </SolutionItemMobile>
                <SolutionItemMobile
                    title={t('solutions.sol2.title')}
                    description={<>{t('solutions.sol2.shortdesc')}</>}
                    Image={Bottle}
                    YOffset={35}
                >
                    <div className="flex flex-col pr-6 justify-start w-full mt-4 space-y-4 items-start h-3/5">
                        <div className='bg-bluekali-cerulean-blue/80 p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol2.types')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                            • <span className="font-semibold">{t('solutions.sol2.clean')}&nbsp;</span>{t('solutions.sol2.clean_desc')}
                            </li>
                            <li>
                            • <span className="font-semibold">{t('solutions.sol2.blue')}&nbsp;</span>{t('solutions.sol2.blue_desc')}
                            </li>
                            <li>
                            • <span className="font-semibold">{t('solutions.sol2.workshop')}&nbsp;</span>{t('solutions.sol2.workshop_desc')}
                            </li>
                            <li>
                            • <span className="font-semibold">{t('solutions.sol2.event')}&nbsp;</span>{t('solutions.sol2.event_desc')}
                            </li>
                        </ul>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 w-3/4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol2.locations')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol2.locations')}</li>
                            <li>{t('solutions.sol2.xalapa')}</li>
                            <li>{t('solutions.sol2.edomex')}</li>
                            <li>{t('solutions.sol2.evaluate')}</li>
                        </ul>
                        </div>

                        
                    </div>
                </SolutionItemMobile>
                <SolutionItemMobile
                    title={t('solutions.sol3.title')}
                    description={<>{t('solutions.sol3.shortdesc')}</>}
                    Image={Sharky}
                    YOffset={70}
                >
                    <div className="flex flex-col justify-start pr-6 w-full mt-4 space-y-4 items-start h-3/5">
                        <div className='bg-bluekali-cerulean-blue/80 p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol3.includes')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol3.eval')}</li>
                            <li>{t('solutions.sol3.transport')}</li>
                            <li>{t('solutions.sol3.operation')}</li>
                            <li>{t('solutions.sol3.recolect')}</li>
                            <li>{t('solutions.sol3.report')}</li>
                            <li>{t('solutions.sol3.brand')}</li>
                        </ul>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol3.benefits')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol3.electric')}</li>
                            <li>{t('solutions.sol3.portable')}</li>
                            <li>{t('solutions.sol3.power')}</li>
                            <li>{t('solutions.sol3.help')}</li>
                            <li>{t('solutions.sol3.nopersonal')}</li>
                            <li>{t('solutions.sol3.dest')}</li>
                        </ul>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol3.price')}</h3>
                        <p className="text-sm mb-2">{t('solutions.sol3.factors')}</p>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol3.chosenlocation')}</li>
                            <li>{t('solutions.sol3.size')}</li>
                        </ul>
                        </div>

                        
                    </div>
                </SolutionItemMobile>
                <SolutionItemMobile
                    title={t('solutions.sol4.title')}
                    description={<>{t('solutions.sol4.shortdesc')}</>}
                    Image={Merch}
                    YOffset={55}
                >
                    <div className="flex flex-col justify-start w-full mt-4 pr-6 space-y-4 items-start h-3/5">
                        <div className='bg-bluekali-cerulean-blue/80 p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol4.offer')}</h3>
                        <ul className="space-y-2 text-sm">
                            <li>{t('solutions.sol4.hoodie')}</li>
                            <li>{t('solutions.sol4.tshirt')}</li>
                            <li>{t('solutions.sol4.tote')}</li>
                        </ul>
                        <p className='text-sm mt-4 text-bluekali-white/80'>{t('solutions.sol4.made')}</p>
                        </div>

                        <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 rounded-md'>
                        <h3 className="text-xl font-semibold mb-2">{t('solutions.sol4.why')}</h3>
                        <p className='text-sm'>
                            {t('solutions.sol4.finance')}
                        </p>
                        </div>

                        
                    </div>
                </SolutionItemMobile>
                
        </div>
    );
}

export default SolutionsMobile;